/**
 * Aquora Pure Water - theme script (vanilla JS)
 */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var strings = (window.AquoraTheme && window.AquoraTheme.strings) || {};
  var lastTrigger = null;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* 1. Scroll reveal (runs once) */
  function initScrollReveal() {
    var items = qsa('.reveal-on-scroll');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window) || reduce) {
      items.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    items.forEach(function (el) { observer.observe(el); });
  }

  /* 2. Sticky header state */
  function initHeader() {
    var header = qs('[data-header]');
    if (!header) return;
    function onScroll() { header.classList.toggle('is-scrolled', window.scrollY > 8); }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* 3. Mobile menu */
  function initMobileMenu() {
    var trigger = qs('[data-mobile-menu-trigger]');
    var menu = qs('[data-mobile-menu]');
    var close = qs('[data-mobile-menu-close]');
    if (!trigger || !menu) return;
    function open() { menu.classList.remove('hidden'); trigger.setAttribute('aria-expanded', 'true'); }
    function shut() { menu.classList.add('hidden'); trigger.setAttribute('aria-expanded', 'false'); trigger.focus(); }
    trigger.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    menu.addEventListener('click', function (e) { if (e.target === menu) shut(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.classList.contains('hidden')) shut(); });
  }

  /* 4. Floating contact panel */
  function initFloatingContact() {
    var trigger = qs('[data-floating-trigger]');
    var panel = qs('[data-floating-panel]');
    var close = qs('[data-floating-close]');
    if (!trigger || !panel) return;
    trigger.addEventListener('click', function () {
      panel.classList.toggle('hidden');
      trigger.setAttribute('aria-expanded', panel.classList.contains('hidden') ? 'false' : 'true');
    });
    if (close) close.addEventListener('click', function () { panel.classList.add('hidden'); trigger.setAttribute('aria-expanded', 'false'); });
  }

  /* 5. Cart drawer */
  function drawer() { return qs('[data-cart-drawer]'); }

  function openDrawer(trigger) {
    var d = drawer();
    if (!d) return;
    lastTrigger = trigger || document.activeElement;
    d.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
    var c = qs('[data-cart-drawer-close]', d);
    if (c) c.focus();
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.add('hidden');
    document.body.style.overflow = '';
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  function showError(message) {
    var d = drawer();
    if (!d) return;
    var el = qs('[data-cart-error]', d);
    if (el) {
      if (message) el.textContent = message;
      el.classList.remove('hidden');
    }
    openDrawer();
  }

  function refreshCart() {
    return Promise.all([
      fetch(root + '?sections=cart-drawer').then(function (r) { return r.json(); }),
      fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
    ]).then(function (res) {
      var live = drawer();
      var parsed = new DOMParser().parseFromString(res[0]['cart-drawer'], 'text/html');
      var fresh = qs('[data-cart-drawer]', parsed);
      if (live && fresh) live.innerHTML = fresh.innerHTML;
      qsa('[data-cart-count]').forEach(function (el) { el.textContent = res[1].item_count; });
    });
  }

  function changeLine(line, quantity) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) {
      if (!r.ok) throw new Error('change');
      return refreshCart();
    }).catch(function () { showError(); });
  }

  function initCartDrawer() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-cart-drawer-trigger]');
      if (trigger) { openDrawer(trigger); return; }
      if (e.target.closest('[data-cart-drawer-close]')) { closeDrawer(); return; }
      var d = drawer();
      if (d && e.target === d) { closeDrawer(); return; }
      var change = e.target.closest('[data-cart-change]');
      if (change) {
        changeLine(parseInt(change.getAttribute('data-cart-change'), 10), parseInt(change.getAttribute('data-qty'), 10));
        return;
      }
      var remove = e.target.closest('[data-cart-remove]');
      if (remove) changeLine(parseInt(remove.getAttribute('data-cart-remove'), 10), 0);
    });

    document.addEventListener('keydown', function (e) {
      var d = drawer();
      if (e.key === 'Escape' && d && !d.classList.contains('hidden')) closeDrawer();
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (form.hasAttribute('data-no-ajax')) return;
      e.preventDefault();
      var btn = qs('[type="submit"]', form);
      if (btn) btn.disabled = true;
      fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
        .then(function (res) {
          if (!res.ok) { showError(res.data && (res.data.description || res.data.message)); return; }
          return refreshCart().then(function () { openDrawer(btn); });
        })
        .catch(function () { showError(); })
        .then(function () { if (btn) btn.disabled = false; });
    });
  }

  /* 6. Quantity steppers */
  function initQuantityInputs() {
    document.addEventListener('click', function (e) {
      var plus = e.target.closest('[data-quantity-plus]');
      var minus = e.target.closest('[data-quantity-minus]');
      if (!plus && !minus) return;
      var container = (plus || minus).closest('[data-quantity-input]');
      var input = container && container.querySelector('[data-quantity-field]');
      if (!input) return;
      var min = parseInt(input.min, 10) || 1;
      var val = parseInt(input.value, 10) || min;
      if (plus) input.value = val + 1;
      else if (val > min) input.value = val - 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* 7. Variant picker (price, availability and URL update without reload) */
  function initVariants() {
    var picker = qs('[data-variant-picker]');
    var dataEl = qs('[data-variants-json]');
    if (!picker || !dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var options = qsa('[data-option-index][aria-pressed="true"]', picker).map(function (b) { return b.getAttribute('data-value'); });
    var idInput = qs('[data-variant-id]');
    var priceEl = qs('[data-product-price]');
    var compareEl = qs('[data-product-compare]');
    var addBtn = qs('[data-add-to-cart]');

    picker.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-option-index]');
      if (!btn) return;
      var index = parseInt(btn.getAttribute('data-option-index'), 10);
      options[index] = btn.getAttribute('data-value');
      qsa('[data-option-index="' + index + '"]', picker).forEach(function (b) {
        var on = b === btn;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        ['border-navy', 'bg-navy', 'text-white', 'font-medium'].forEach(function (c) { b.classList.toggle(c, on); });
        ['border-ink/20', 'text-ink'].forEach(function (c) { b.classList.toggle(c, !on); });
      });
      var label = btn.closest('.space-y-2').querySelector('[data-option-selected]');
      if (label) label.textContent = options[index];

      var match = variants.filter(function (v) { return v.options.join('|') === options.join('|'); })[0];
      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = strings.unavailable || 'Unavailable'; }
        return;
      }
      if (match.media_id) document.dispatchEvent(new CustomEvent('variant:media', { detail: { id: String(match.media_id) } }));
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      if (compareEl) {
        compareEl.textContent = match.compare || '';
        compareEl.classList.toggle('hidden', !match.compare);
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    });
  }

  /* 8. Collection sort */
  function initSort() {
    var select = qs('#SortBy');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* 9. Custom label quote dialog */
  function initCustomLabelDialog() {
    var dlg = qs('[data-custom-modal]');
    if (!dlg) return;
    function open() { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); }
    function shut() { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
    qsa('[data-custom-modal-trigger]').forEach(function (b) { b.addEventListener('click', open); });
    qsa('[data-custom-modal-close]', dlg).forEach(function (b) { b.addEventListener('click', shut); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) shut(); });
    if (dlg.hasAttribute('data-open-on-load')) open();
  }

  /* 10. Product media gallery */
  function initMediaGallery() {
    qsa('[data-media-gallery]').forEach(function (gallery) {
      var items = qsa('[data-media-item]', gallery);
      var thumbs = qsa('[data-media-thumb]', gallery);
      function showMedia(id) {
        var found = items.some(function (item) { return item.getAttribute('data-media-item') === id; });
        if (!found) return;
        items.forEach(function (item) {
          var on = item.getAttribute('data-media-item') === id;
          item.classList.toggle('hidden', !on);
          qsa('video', item).forEach(function (v) { if (!on) v.pause(); });
        });
        thumbs.forEach(function (t) {
          var on = t.getAttribute('data-media-thumb') === id;
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (on && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
      }
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () { showMedia(thumb.getAttribute('data-media-thumb')); });
      });
      document.addEventListener('variant:media', function (e) { showMedia(e.detail.id); });
    });
  }

  /* 11. Category marquee pause */
  function initCategoryMarquee() {
    var marquee = qs('[data-cat-marquee]');
    var btn = qs('[data-cat-pause]');
    if (!marquee || !btn) return;
    var label = qs('[data-cat-pause-label]', btn);
    btn.addEventListener('click', function () {
      var paused = marquee.classList.toggle('is-paused');
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      if (label) label.textContent = paused ? 'Play' : 'Pause';
    });
  }

  /* 12. Product card videos: play only while visible */
  function initCardVideos() {
    var videos = qsa('[data-card-video]');
    if (!videos.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.25 });
    videos.forEach(function (v) { io.observe(v); });
  }

  /* 13. Selling plan picker */
  function initSellingPlans() {
    qsa('[data-selling-plans]').forEach(function (box) {
      var input = qs('[data-selling-plan-input]', box);
      if (!input) return;
      box.addEventListener('change', function (e) {
        if (!e.target.matches('[data-plan-radio]')) return;
        input.value = e.target.value;
        input.disabled = !e.target.value;
      });
    });
  }

  /* 14. Custom label bottle preview */
  function initLogoPreview() {
    var root = qs('[data-label-preview]');
    if (!root) return;
    var data = [];
    try { data = JSON.parse(qs('[data-bottle-data]', root).textContent) || []; } catch (err) { data = []; }
    var wrap = qs('[data-photo-wrap]', root);
    var photo = qs('[data-bottle-img]', root);
    var box = qs('[data-label-box]', root);
    var img = qs('[data-logo-img]', root);
    var placeholder = qs('[data-logo-placeholder]', root);
    var status = qs('[data-logo-status]', root);
    var clearBtn = qs('[data-logo-clear]', root);
    var input = qs('[data-logo-input]', root);
    var colourSel = qs('[data-label-colour]', root);
    var sizeInput = qs('[data-logo-size]', root);
    var shapeGroup = qs('[data-shape-group]', root);
    var shapeList = qs('[data-shape-list]', root);
    var sizeSel = qs('[data-size-select]', root);
    var typeSel = qs('[data-type-select]', root);
    var formSize = qs('[data-form-size]');
    var formType = qs('[data-form-type]');
    var STAGE_H = 380;
    var sizeOrder = ['330ml', '500ml', '1.5L'];
    var defaultStatus = status ? status.textContent : '';
    var allowed = ['image/png', 'image/jpeg', 'image/svg+xml', 'image/webp'];
    var maxBytes = 5 * 1024 * 1024;
    var currentUrl = null;
    var logoFile = null;
    var colours = { white: ['#ffffff', '#06222f'], navy: ['#0a4c7a', '#ffffff'], black: ['#06222f', '#ffffff'], clear: ['transparent', '#06222f'] };

    function field(name) { return qs('[data-field-' + name + ']'); }
    function setField(name, value) { qsa('[data-field-' + name + ']').forEach(function (f) { f.value = value; }); }
    function say(msg) { if (status) status.textContent = msg; }

    var shapes = [];
    data.forEach(function (b) { if (shapes.indexOf(b.shape) === -1) shapes.push(b.shape); });
    function sizesFor(shape) {
      return data.filter(function (b) { return b.shape === shape; }).map(function (b) { return b.size; })
        .sort(function (a, c) { return sizeOrder.indexOf(a) - sizeOrder.indexOf(c); });
    }
    function find(shape, size) { return data.filter(function (b) { return b.shape === shape && b.size === size; })[0]; }

    var state = { shape: shapes[0] || '', size: '', type: 'Mineral' };
    state.size = sizesFor(state.shape)[0] || '';

    function setState(next) {
      if (next.type) state.type = next.type;
      if (next.shape && next.shape !== state.shape) {
        state.shape = next.shape;
        if (!find(state.shape, state.size)) state.size = sizesFor(state.shape)[0];
      }
      if (next.size) {
        var alt = data.filter(function (b) { return b.size === next.size; })[0];
        if (!find(state.shape, next.size) && alt) state.shape = alt.shape;
        state.size = next.size;
      }
      render();
    }

    function buildShapes() {
      if (!shapeList) return;
      shapeList.textContent = '';
      shapes.forEach(function (name) {
        var first = data.filter(function (b) { return b.shape === name; })[0];
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'bp-shape'; btn.setAttribute('data-shape', name);
        var t = document.createElement('img'); t.src = first.thumb; t.alt = ''; t.loading = 'lazy';
        var l = document.createElement('span'); l.textContent = name;
        btn.appendChild(t); btn.appendChild(l);
        btn.addEventListener('click', function () { setState({ shape: name }); });
        shapeList.appendChild(btn);
      });
      if (shapeGroup) shapeGroup.hidden = shapes.length < 2;
    }

    function render() {
      var b = find(state.shape, state.size);
      if (b) {
        var url = b.images[state.type] || b.images.Mineral;
        if (photo.getAttribute('src') !== url) photo.src = url;
        photo.alt = state.shape + ' ' + state.size + ' ' + state.type + ' water bottle, unbranded';
        photo.style.height = (STAGE_H * (b.height || 100) / 100) + 'px';
        photo.hidden = false;
        wrap.classList.remove('is-flat');
        box.style.left = b.label.x + '%'; box.style.top = b.label.y + '%';
        box.style.width = b.label.w + '%'; box.style.height = b.label.h + '%';
      } else {
        photo.hidden = true; photo.removeAttribute('src');
        wrap.classList.add('is-flat');
        box.style.left = '8%'; box.style.top = '10%'; box.style.width = '84%'; box.style.height = '80%';
      }
      qsa('[data-shape]', root).forEach(function (btn) { btn.setAttribute('aria-pressed', btn.getAttribute('data-shape') === state.shape ? 'true' : 'false'); });
      var sizes = sizeOrder;
      var flatNote = qs('[data-flat-note]', root);
      if (flatNote) flatNote.hidden = !(data.length && !b);
      sizeSel.textContent = '';
      sizes.forEach(function (s) { var o = document.createElement('option'); o.textContent = s; o.value = s; sizeSel.appendChild(o); });
      sizeSel.value = state.size || sizes[0];
      typeSel.value = state.type;
      setField('shape', data.length ? state.shape : '');
      setField('type', state.type);
      if (typeof updateOrder === 'function') updateOrder();
      if (formSize && qsa('option', formSize).some(function (o) { return o.value === sizeSel.value; })) formSize.value = sizeSel.value;
      if (formType && qsa('option', formType).some(function (o) { return o.value === state.type; })) formType.value = state.type;
    }

    function applyColour() {
      var c = colours[colourSel.value] || colours.white;
      box.style.setProperty('--label-bg', c[0]); box.style.setProperty('--label-fg', c[1]);
      box.classList.toggle('is-clear', colourSel.value === 'clear');
      setField('label-colour', colourSel.value);
    }
    function applySize() {
      box.style.setProperty('--logo-size', sizeInput.value + '%');
      setField('logo-size', sizeInput.value + '%');
    }
    function clearLogo() {
      if (currentUrl) { URL.revokeObjectURL(currentUrl); currentUrl = null; }
      img.removeAttribute('src'); img.hidden = true; placeholder.hidden = false;
      if (clearBtn) clearBtn.hidden = true;
      input.value = ''; logoFile = null; setField('logo-name', ''); say(defaultStatus);
    }

    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      if (!file) { clearLogo(); return; }
      if (allowed.indexOf(file.type) === -1) { clearLogo(); say('Please choose a PNG, JPG, SVG or WebP image.'); return; }
      if (file.size > maxBytes) { clearLogo(); say('That file is over 5 MB. Please choose a smaller image.'); return; }
      if (currentUrl) URL.revokeObjectURL(currentUrl);
      currentUrl = URL.createObjectURL(file);
      logoFile = file;
      img.onerror = function () { clearLogo(); say('We could not read that image. Please try another file.'); };
      img.src = currentUrl; img.alt = 'Preview of your logo on the bottle label';
      img.hidden = false; placeholder.hidden = true;
      if (clearBtn) clearBtn.hidden = false;
      setField('logo-name', file.name);
      say('Previewing ' + file.name + '. Send us the file with your quote request.');
    });
    colourSel.addEventListener('change', applyColour);
    sizeInput.addEventListener('input', applySize);
    if (clearBtn) clearBtn.addEventListener('click', clearLogo);
    sizeSel.addEventListener('change', function () { setState({ size: sizeSel.value }); });
    typeSel.addEventListener('change', function () { setState({ type: typeSel.value }); });
    if (formSize) formSize.addEventListener('change', function () { setState({ size: formSize.value }); });
    if (formType) formType.addEventListener('change', function () { setState({ type: formType.value }); });
    if (/[?&]labelguide=1/.test(window.location.search)) box.classList.add('is-guide');


    /* ---- Ordering: quantity, turnaround, delivery date, add to cart with logo + mockup ---- */
    var orderForm = qs('[data-order-form]', root);
    var panel = qs('[data-order-panel]', root);
    var orderCfg = null, orderProd = null;
    if (panel) {
      try {
        orderCfg = JSON.parse(qs('[data-order-config]', root).textContent);
        orderProd = JSON.parse(qs('[data-order-product-json]', root).textContent);
      } catch (err) { panel = null; }
    }
    var qtyEl, dateEl, variantEl, summaryEl, errorEl, hintEl, extraEl, submitBtn, turnField;
    var sizeIdx = 0, turnIdx = -1, blocked = [];
    if (panel) {
      qtyEl = qs('[data-order-qty]', root); dateEl = qs('[data-order-date]', root);
      variantEl = qs('[data-order-variant]', root); summaryEl = qs('[data-order-summary]', root);
      errorEl = qs('[data-order-error]', root); hintEl = qs('[data-delivery-hint]', root);
      extraEl = qs('[data-express-extra]', root); submitBtn = qs('[data-order-submit]', root);
      turnField = qs('[data-order-turnaround-field]', root);
      orderForm.enctype = 'multipart/form-data';
      orderProd.options.forEach(function (n, i) {
        if (/size/i.test(n)) sizeIdx = i;
        else if (/turnaround|speed|delivery/i.test(n)) turnIdx = i;
      });
      if (turnIdx === -1 && orderProd.options.length > 1) turnIdx = sizeIdx === 0 ? 1 : 0;
      blocked = String(orderCfg.blocked || '').match(/\d{4}-\d{2}-\d{2}/g) || [];
    }
    function money(cents) {
      try { return new Intl.NumberFormat('en-ZA', { style: 'currency', currency: orderCfg.currency }).format(cents / 100); }
      catch (err) { return (cents / 100).toFixed(2); }
    }
    function turn() { var r = qs('[data-turnaround]:checked', root); return r ? r.value : 'standard'; }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
    function isBizDay(d) { var g = d.getDay(); return g !== 0 && g !== 6 && blocked.indexOf(iso(d)) === -1; }
    function saNow() {
      var out = { y: 0, m: 0, d: 0, h: 0 };
      try {
        new Intl.DateTimeFormat('en-GB', { timeZone: 'Africa/Johannesburg', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' })
          .formatToParts(new Date()).forEach(function (p) {
            if (p.type === 'year') out.y = +p.value; else if (p.type === 'month') out.m = +p.value;
            else if (p.type === 'day') out.d = +p.value; else if (p.type === 'hour') out.h = +p.value;
          });
      } catch (err) { var n = new Date(); out = { y: n.getFullYear(), m: n.getMonth() + 1, d: n.getDate(), h: n.getHours() }; }
      return out;
    }
    function earliest(n) {
      var now = saNow();
      var d = new Date(now.y, now.m - 1, now.d);
      var cutoff = orderCfg.cutoff || 14;
      if (!isBizDay(d) || now.h >= cutoff) { do { d.setDate(d.getDate() + 1); } while (!isBizDay(d)); }
      var c = 0;
      while (c < n) { d.setDate(d.getDate() + 1); if (isBizDay(d)) c++; }
      return d;
    }
    function hourLabel(h) { return (h % 12 || 12) + (h < 12 ? 'am' : 'pm'); }
    function parseDate(v) { var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v || ''); return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null; }
    function variantFor(size, t) {
      var s = String(size).toLowerCase();
      return orderProd.variants.filter(function (v) {
        if (String(v.options[sizeIdx]).toLowerCase() !== s) return false;
        if (turnIdx === -1) return t === 'standard';
        return String(v.options[turnIdx]).toLowerCase().indexOf(t) === 0;
      })[0];
    }
    function showError(msg) { if (!errorEl) return; errorEl.textContent = msg || ''; errorEl.hidden = !msg; }
    function updateOrder() {
      if (!panel) return;
      var t = turn();
      var days = t === 'express' ? orderCfg.express : orderCfg.standard;
      var std = variantFor(state.size, 'standard'), exp = variantFor(state.size, 'express');
      var v = variantFor(state.size, t);
      var expRadio = qs('[data-turnaround][value="express"]', root);
      if (expRadio) { expRadio.disabled = !exp; if (!exp && t === 'express') { qs('[data-turnaround][value="standard"]', root).checked = true; return updateOrder(); } }
      if (extraEl) extraEl.textContent = (std && exp && exp.price > std.price) ? '+' + money(exp.price - std.price) + ' per bottle' : '';
      var min = earliest(days);
      dateEl.min = iso(min);
      var cur = parseDate(dateEl.value);
      if (cur && cur < min) { dateEl.value = ''; }
      if (hintEl) hintEl.textContent = 'Earliest delivery date: ' + min.toLocaleDateString('en-ZA', { weekday: 'long', day: 'numeric', month: 'long' }) + ' (' + days + ' business days). Weekdays only. Orders placed after ' + hourLabel(orderCfg.cutoff || 14) + ' (SA time) count from the next business day.';
      var qty = parseInt(qtyEl.value, 10) || 0;
      if (v && v.available) {
        variantEl.value = v.id;
        summaryEl.textContent = state.size + ' ' + state.type + ': ' + money(v.price) + ' per bottle x ' + qty + ' = ' + money(v.price * qty);
        submitBtn.disabled = false;
      } else {
        variantEl.value = '';
        summaryEl.textContent = 'This size and turnaround is not available to order online. Please request a quote.';
        submitBtn.disabled = true;
      }
      if (turnField) turnField.value = (t === 'express' ? 'Express' : 'Standard') + ' (' + days + ' business days)';
    }
    if (panel) {
      qsa('[data-turnaround]', root).forEach(function (r) { r.addEventListener('change', function () { showError(''); updateOrder(); }); });
      qtyEl.addEventListener('input', updateOrder);
      dateEl.addEventListener('change', function () { showError(''); });
    }

    function loadImg(src, cors) {
      return new Promise(function (resolve) {
        var i = new Image();
        if (cors) i.crossOrigin = 'anonymous';
        i.onload = function () { resolve(i); };
        i.onerror = function () { resolve(null); };
        i.src = src;
      });
    }
    function canvasBlob(c) {
      return new Promise(function (resolve) {
        try { c.toBlob(function (b) { resolve(b); }, 'image/png'); } catch (err) { resolve(null); }
      });
    }
    function buildMockup() {
      var b = find(state.shape, state.size);
      var photoUrl = b ? (b.images[state.type] || b.images.Mineral) : null;
      return Promise.all([photoUrl ? loadImg(photoUrl, true) : Promise.resolve(null), currentUrl ? loadImg(currentUrl, false) : Promise.resolve(null)]).then(function (res) {
        var photoImg = res[0], logoImg = res[1];
        if (photoUrl && !photoImg) return null;
        var W, H, lab;
        if (photoImg) {
          var sc = Math.min(1, 1200 / Math.max(photoImg.naturalWidth, photoImg.naturalHeight));
          W = Math.round(photoImg.naturalWidth * sc); H = Math.round(photoImg.naturalHeight * sc);
          lab = b.label;
        } else { W = 960; H = 600; lab = { x: 8, y: 10, w: 84, h: 80 }; }
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var ctx = c.getContext('2d');
        ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, W, H);
        if (photoImg) ctx.drawImage(photoImg, 0, 0, W, H);
        var lx = W * lab.x / 100, ly = H * lab.y / 100, lw = W * lab.w / 100, lh = H * lab.h / 100;
        var col = colours[colourSel.value] || colours.white;
        if (colourSel.value !== 'clear') { ctx.fillStyle = col[0]; ctx.fillRect(lx, ly, lw, lh); }
        else if (!photoImg) { ctx.strokeStyle = '#d7e3e8'; ctx.strokeRect(lx, ly, lw, lh); }
        if (logoImg && logoImg.naturalWidth) {
          var maxW = lw * sizeInput.value / 100, maxH = lh * 0.8;
          var r = Math.min(maxW / logoImg.naturalWidth, maxH / logoImg.naturalHeight);
          var dw = logoImg.naturalWidth * r, dh = logoImg.naturalHeight * r;
          if (colourSel.value === 'clear') ctx.globalCompositeOperation = 'multiply';
          ctx.drawImage(logoImg, lx + (lw - dw) / 2, ly + (lh - dh) / 2, dw, dh);
          ctx.globalCompositeOperation = 'source-over';
        }
        if (colourSel.value === 'clear') return canvasBlob(c);
        var g = ctx.createLinearGradient(lx, 0, lx + lw, 0);
        g.addColorStop(0, 'rgba(6,34,47,.16)'); g.addColorStop(.3, 'rgba(255,255,255,.28)');
        g.addColorStop(.55, 'rgba(255,255,255,0)'); g.addColorStop(1, 'rgba(6,34,47,.18)');
        ctx.fillStyle = g; ctx.fillRect(lx, ly, lw, lh);
        return canvasBlob(c);
      });
    }
    function logoForUpload() {
      if (logoFile.type !== 'image/svg+xml') return Promise.resolve({ file: logoFile, note: '' });
      return loadImg(currentUrl, false).then(function (i) {
        if (!i) return { file: null, note: 'SVG could not be converted' };
        var w = i.naturalWidth || 1000, h = i.naturalHeight || 1000;
        var sc = 2000 / Math.max(w, h);
        var c = document.createElement('canvas'); c.width = Math.round(w * sc); c.height = Math.round(h * sc);
        c.getContext('2d').drawImage(i, 0, 0, c.width, c.height);
        return canvasBlob(c).then(function (blob) {
          return { file: blob ? new File([blob], 'logo.png', { type: 'image/png' }) : null, note: 'Customer supplied an SVG; converted to PNG for upload. Ask for the original vector file.' };
        });
      });
    }
    function attach(inputEl, file) {
      var dt = new DataTransfer(); dt.items.add(file); inputEl.files = dt.files;
    }
    if (panel) {
      orderForm.addEventListener('submit', function (e) {
        e.preventDefault();
        showError('');
        var qty = parseInt(qtyEl.value, 10) || 0;
        var d = parseDate(dateEl.value);
        var min = earliest(turn() === 'express' ? orderCfg.express : orderCfg.standard);
        if (!variantEl.value) { showError('This size and turnaround is not available to order online. Please request a quote.'); return; }
        if (!logoFile) { showError('Please upload your logo so we can print it and attach it to your order.'); return; }
        if (qty < orderCfg.min) { showError('The minimum order is ' + orderCfg.min + ' bottles.'); return; }
        if (!d) { showError('Please choose a delivery date.'); return; }
        if (d < min || !isBizDay(d)) { showError('Please choose a weekday on or after ' + iso(min) + ' that is not a holiday or closure.'); return; }
        if (typeof DataTransfer !== 'function') { showError('Your browser cannot attach files. Please use the quote request instead.'); return; }
        var label = submitBtn.textContent;
        submitBtn.disabled = true; submitBtn.textContent = 'Preparing your mockup...';
        Promise.all([logoForUpload(), buildMockup()]).then(function (out) {
          var logo = out[0], mock = out[1];
          if (!logo.file) { showError('We could not prepare your logo. Please upload a PNG or JPG.'); submitBtn.disabled = false; submitBtn.textContent = label; return; }
          attach(qs('[data-order-logo-file]', root), logo.file);
          qs('[data-order-logo-note]', root).value = logo.note;
          if (mock) { attach(qs('[data-order-mockup-file]', root), new File([mock], 'mockup.png', { type: 'image/png' })); qs('[data-order-mockup-note]', root).value = ''; }
          else qs('[data-order-mockup-note]', root).value = 'Mockup image could not be generated in the browser. See the selections listed on this order.';
          orderForm.submit();
        }).catch(function () { showError('Something went wrong preparing your order. Please try again or request a quote.'); submitBtn.disabled = false; submitBtn.textContent = label; });
      });
    }

    buildShapes(); applyColour(); applySize();
    setState({ size: formSize ? formSize.value : undefined, type: formType ? formType.value : undefined });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initScrollReveal();
    initHeader();
    initMobileMenu();
    initFloatingContact();
    initCartDrawer();
    initQuantityInputs();
    initVariants();
    initSort();
    initCategoryMarquee();
    initMediaGallery();
    initCardVideos();
    initSellingPlans();
    initLogoPreview();
    initCustomLabelDialog();
  });
})();
